import { useSelector } from 'react-redux';
import { SkeletonItem, SkeletonList } from 'shared/components/SkeletonList';
import { selectOffers } from 'shared/selectors/offers';
import { getSkeletonItemsNodes } from '../../utils';
import { IOffer } from '../../../../../packages/OfferCardWidget';

export const SkeletonListContainerDesktop = () => {
  const offers = useSelector(selectOffers) as IOffer[];

  const offersSkeletons = offers.map(({ showGalleryThumbnails, photos }) => ({
    isWide: !!showGalleryThumbnails && photos.length > 1,
  }));

  return <SkeletonList items={getSkeletonItemsNodes(offersSkeletons, SkeletonItem)} />;
};
